<template lang="pug">
  #signUpSuccess.d-flex.flex-column(
    style="height: 100vh; padding-bottom: 0;"
  )
    .container-width.text-center.w-100
      div
        img.logo(:src="require('@/assets/images/logo/logo-activity.png')", alt="tiffany_logo")
      div.info
        .mt-5
          .title 您已成為 Tiffany & Co. 摯友！
        .mt-3
        .content
          div 2026/5/10(日)前預約鑑賞
          div 即可獲得品牌體驗禮

      div.button-area
        div.button(
          @click="goToSource()"
        ) 立即前往預約
      


</template>

<script>

export default {
  name: 'memberSuccess',
   props: {
    // 是否綁定成功且順便綁定CA了
    source: {
      type: String,
      required: false
    },
    act: {
      type: String,
      required: false
    },
    line_uuid: {
      type: String,
      required: false
    },
  },
  data() {
    return {
    };
  },
  mounted() {
    const vm = this;
    document.getElementById('appHeader').style.display = 'none';
    document.getElementById('appFooter').style.display = 'none';
    vm.$store.commit('toggleLoading', false);
  },
  methods: {
    goToSource() {
      window.location = this.source + '?act=' + this.act + '&route=reserve';
    }
  },
  computed: {
  }
};
</script>

<style lang="scss" scoped>
@font-face {
  font-family: 'Noto Serif TC';
  src: url('~@/assets/fonts/NotoSerifTC-Regular.ttf') format('truetype');
}
.container-width {
  font-family: 'Noto Serif TC';
  text-align: center;
  flex: 1;
  background: linear-gradient(180deg, #081B28 0%, #3A666F 34.62%, #5A959B 100%);
  display: flex;
  flex-direction: column;
}

.logo {
  min-width: 150px;
  width: 170px;
  margin: 60px auto 40px auto;
}
.info {
  margin-top: 100px;
}
.title {
  font-style: normal;
  font-weight: 700;
  font-size: 20px;
  line-height: 170%;
  letter-spacing: 0.05em;
  color: #FFFFFF;
}

.content {
  font-size: 14px;
  line-height: 170%;
  letter-spacing: 0.05em;
  color: #FFFFFF;
}

.button-area {
  position: absolute;
  bottom: 70px;
  left: 50%;
  transform: translateX(-50%);
  .button {
    width: 170px;
    min-width: 150px;
    height: 45px;
    border: 1px solid #FFFFFF;
    color: #ffffff;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>